<style>
  .selected-autocomplete-element {
    background-color: red;
  }
  .selectable-autocomplete-option {
    cursor: pointer;
  }
</style>
<div
  class="entry-field"
  [ngClass]="getLevelClass()"
  [class.entry-field--disabled]="isDisabled || disableConditionally"
  [class.entry-field--error]="isError()"
>
  <basic-label *ngIf="!placeholder" [noIndent]="true"></basic-label>
  <div class="input-label-container">
    <label
      *ngIf="placeholder"
      class="entry-field__label"
      for="{{ componentId }}"
      [class.entry-field--error__label]="errorMessage[prop]"
      [class.entry-field--filled__label]="!errorMessage[prop] && !!query.listValue"
    >
      {{ placeholder }}
    </label>
    <input
      type="text"
      id="{{ componentId }}"
      [placeholder]="isSelect ? 'Select' : ''"
      class="entry-field__input entry-field__no-overflow"
      [ngClass]="getClasses()"
      (change)="trigger()"
      (blur)="handleBlur()"
      [(ngModel)]="query.listValue"
      (keyup)="handleKeyUpInteractions($event.keyCode)"
      [disabled]="isDisabled || disableConditionally"
      autocomplete="new-password"
      (keydown.Tab)="handleTab()"
    />
  </div>
  <div class="suggestions" *ngIf="filteredList.length > 0">
    <ul>
      <li
        class="suggestion__item"
        *ngFor="let item of filteredList; let i = index"
        [class.suggestion__item--selected]="i === selectedIndex"
        (click)="select(item)"
      >
        {{ item.listValue }}
      </li>
    </ul>
  </div>
  <p *ngIf="isError()" class="error-message">
    {{ getErrorMessage() }}
  </p>
</div>
